import {
  UserInfo,
  UserInfoDto,
  WorksheetData,
} from '../../pages/Registration/Registration.interfaces';
import { UpdateTestDto } from '../../pages/Registration/Test/Test.interfaces';
import { api } from './api';
import {
  ChangePasswordDto,
  Country,
  DocumentTemplate,
  UploadDocument,
} from './types.api';

interface ChangePasswordResponse { }

export type CatalogDto = {
  name: string;
};

export type CatalogResponse = {
  data: DocumentTemplate[] | Country[];
};

export type FileDataResponse = {
  errors?: unknown;
  data: string;
  fileName: string;
  extension?: string;
};

interface TestUpdateResponse {
  result: true;
  answersQty: number;
  correctAnswersQty: number;
}

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // получение данных о пользователе
    getUserInfo: builder.query<UserInfo, void>({
      query: () => {
        return {
          url: 'user_info',
        };
      },
      providesTags: ['userInfo'],
    }),

    // смена пароля
    changePassword: builder.mutation<ChangePasswordResponse, ChangePasswordDto>(
      {
        query: (data) => ({
          url: 'user_setpassword',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['userInfo'],
      },
    ),

    // авторизация basic
    logout: builder.query<unknown, void>({
      query: () => ({
        url: 'logout',
      }),
    }),

    // получить каталоги/справочники (валюты, документы и т.д.)
    getCatalog: builder.mutation<CatalogResponse, { name: string }>({
      query: (data) => {
        return {
          url: 'catalog',
          method: 'POST',
          body: data,
        };
      },
    }),

    // обновить информацию о пользователе
    updateUserInfo: builder.mutation<any, WorksheetData>({
      query: (data) => {
        return {
          url: 'user_update',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['userInfo'],
    }),

    // скачать файл по id
    getFileBase64: builder.mutation<FileDataResponse, { fileId: string }>({
      query: (data) => {
        return {
          url: 'filedata',
          method: 'POST',
          body: data,
        };
      },
    }),

    // добавить документ
    uploadFile: builder.mutation<FileDataResponse, UploadDocument>({
      query: (data) => {
        return {
          url: 'user_add_document',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['userInfo'],
    }),

    // удалить документ
    deleteFile: builder.mutation<'{}', { fileId: string }>({
      query: (data) => {
        return {
          url: 'user_delete_document',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['userInfo'],
    }),

    // отправка результатов тестирования
    testUpdate: builder.mutation<TestUpdateResponse, UpdateTestDto>({
      query: (data) => {
        return {
          url: 'test_update',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['userInfo'],
    }),
  }),
});
